/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import Component from 'can/component/component';
import InstagramApi from 'scripts/social/instagram';
import template from './instagram-embed.stache';
import IframeClickHandler from 'scripts/services/iframe-click-service';

const POST_URL_REG_EXP = /https?:\/\/(www.)?instagram\.com\/p\/([^\/\?#]+)/gi;

Component.extend({
    tag: 'instagram-embed',
    template: template,
    events: {
        inserted: function() {
            const instagramOptions = {
                embed: this.viewModel.attr('embed'),
            };
            InstagramApi.create(
                this.element.find('.c-instagram-embed'),
                instagramOptions,
                function() {
                    this.element.find('.c-instagram-embed iframe').css({
                        transition:
                            'max-height 0.5s cubic-bezier(0.6, -0.28, 0.735, 0.045)',
                    });
                }.bind(this),
            );
            this.registerClickListener();
        },

        registerClickListener() {
            this.iframeListener = new IframeClickHandler('.c-instagram-embed');
            this.iframeListener.subscribe(() => this.element.trigger('click'));
        },

        removed() {
            if (Boolean(this.iframeListener)) {
                this.iframeListener.unsubscribe();
            }
        },

        parsePostUrl: function() {
            if (this.viewModel.attr('postUrl')) {
                let regexp = new RegExp(POST_URL_REG_EXP);
                let hrefArr = regexp.exec(this.viewModel.attr('postUrl'));
                return hrefArr && hrefArr[2] ? hrefArr[2] : null;
            } else {
                return null;
            }
        },
    },
});
